export enum FieldNames {
	FIRST_NAME = 'first_name',
	LAST_NAME = 'last_name',
	MIDDLE_NAME = 'middle_name',
	PHONE = 'phone',
	INN = 'inn',
	PASSPORT_SERIES = 'passport_series',
	PASSPORT_NUMBER = 'passport_number',
	PASSPORT_GIVEN_DATE = 'passport_given_date',
	BIRTH_DATE = 'birth_date',
	COMPANY_NAME = 'company_name',
}
